import React, { useState } from 'react';
import '../../../assests/css/admin/AdminAttendance.css';
import {
  FileText,
  Eye,
  Trash2,
  CheckCircle,
  XCircle
} from 'lucide-react';

import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';

const AdminAttendance = () => {
  const [activeTab, setActiveTab] = useState('teacherRecords');

  /* =========================
     Teacher Attendance Data
  ========================== */
  const [attendanceRecords] = useState([
    // {
    //   id: 1,
    //   teacher: 'Dr. Ahmed Ali',
    //   date: '2026-01-15',
    //   session: 'Morning Session',
    //   checkIn: '09:05 AM',
    //   checkOut: '12:00 PM',
    //   status: 'present'
    // },
    // {
    //   id: 2,
    //   teacher: 'Prof. Sarah Khan',
    //   date: '2026-01-15',
    //   session: 'Afternoon Session',
    //   checkIn: '02:10 PM',
    //   checkOut: '05:00 PM',
    //   status: 'present'
    // },
    // {
    //   id: 3,
    //   teacher: 'Mr. Hassan Raza',
    //   date: '2026-01-15',
    //   session: 'Evening Session',
    //   checkIn: '-',
    //   checkOut: '-',
    //   status: 'absent'
    // }
  ]);

  /* =========================
     Student Attendance Data
  ========================== */
  const [studentattendanceRecords] = useState([
    // {
    //   id: 1,
    //   student: 'Ali Raza',
    //   date: '2026-01-15',
    //   session: 'Morning Session',
    //   checkIn: '09:00 AM',
    //   checkOut: '12:00 PM',
    //   status: 'present'
    // },
    // {
    //   id: 2,
    //   student: 'Ayesha Noor',
    //   date: '2026-01-15',
    //   session: 'Afternoon Session',
    //   checkIn: '-',
    //   checkOut: '-',
    //   status: 'absent'
    // },
    // {
    //   id: 3,
    //   student: 'Hassan Ali',
    //   date: '2026-01-15',
    //   session: 'Morning Session',
    //   checkIn: '09:15 AM',
    //   checkOut: '12:00 PM',
    //   status: 'present'
    // }
  ]);

  return (
    <Adminmasterlayout>
      <div className="aa">
        <div className="aa__container">

          {/* =========================
              Header
          ========================== */}
          <div className="aa__header">
            <div className="aa__header-content">
              <h1 className="aa__header-title">
                Attendance Management
              </h1>

              <p className="aa__header-subtitle">
                Manage Teacher and Student Attendance Records
              </p>
            </div>
          </div>

          {/* =========================
              Tabs
          ========================== */}
          <div className="aa__tabs">

            {/* Teacher Attendance Tab */}
            <button
              className={`aa__tab ${
                activeTab === 'teacherRecords'
                  ? 'aa__tab--active'
                  : ''
              }`}
              onClick={() => setActiveTab('teacherRecords')}
            >
              <FileText size={18} />
              Teacher Attendance
            </button>

            {/* Student Attendance Tab */}
            <button
              className={`aa__tab ${
                activeTab === 'studentRecords'
                  ? 'aa__tab--active'
                  : ''
              }`}
              onClick={() => setActiveTab('studentRecords')}
            >
              <FileText size={18} />
              Student Attendance
            </button>
          </div>

          {/* =========================
              Content
          ========================== */}
          <div className="aa__content">

            {/* =====================================================
                Teacher Attendance Records
            ====================================================== */}
            {activeTab === 'teacherRecords' && (
              <div className="aa__records">

                <div className="aa__records-header">
                  <h2 className="aa__records-heading">
                    Teacher Attendance Records
                  </h2>

                  <div className="aa__records-filters">
                    <input
                      type="date"
                      className="aa__filter-input"
                    />

                    <select className="aa__filter-select">
                      <option value="">All Sessions</option>
                      <option value="morning">Morning</option>
                      <option value="afternoon">Afternoon</option>
                      <option value="evening">Evening</option>
                    </select>
                  </div>
                </div>

                <div className="aa__table-wrapper">
                  <table className="aa__table">

                    <thead className="aa__table-head">
                      <tr className="aa__table-row">
                        <th className="aa__table-header">
                          Teacher Name
                        </th>

                        <th className="aa__table-header">
                          Date
                        </th>

                        <th className="aa__table-header">
                          Session
                        </th>

                        <th className="aa__table-header">
                          Check-In
                        </th>

                        <th className="aa__table-header">
                          Check-Out
                        </th>

                        <th className="aa__table-header">
                          Status
                        </th>

                        <th className="aa__table-header">
                          Actions
                        </th>
                      </tr>
                    </thead>

                    <tbody className="aa__table-body">
                      {attendanceRecords.map((record) => (
                        <tr
                          key={record.id}
                          className="aa__table-row"
                        >
                          <td className="aa__table-cell aa__table-cell--name">
                            {record.teacher}
                          </td>

                          <td className="aa__table-cell">
                            {record.date}
                          </td>

                          <td className="aa__table-cell">
                            <span className="aa__table-badge">
                              {record.session}
                            </span>
                          </td>

                          <td className="aa__table-cell">
                            {record.checkIn}
                          </td>

                          <td className="aa__table-cell">
                            {record.checkOut}
                          </td>

                          <td className="aa__table-cell">
                            <span
                              className={`aa__table-status aa__table-status--${record.status}`}
                            >
                              {record.status === 'present' ? (
                                <CheckCircle size={16} />
                              ) : (
                                <XCircle size={16} />
                              )}

                              {record.status}
                            </span>
                          </td>

                          <td className="aa__table-cell">
                            <div className="aa__table-actions">

                              <button
                                className="aa__table-btn aa__table-btn--view"
                                title="View"
                              >
                                <Eye size={16} />
                              </button>

                              <button
                                className="aa__table-btn aa__table-btn--delete"
                                title="Delete"
                              >
                                <Trash2 size={16} />
                              </button>

                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                  </table>
                </div>
              </div>
            )}

            {/* =====================================================
                Student Attendance Records
            ====================================================== */}
            {activeTab === 'studentRecords' && (
              <div className="aa__records">

                <div className="aa__records-header">
                  <h2 className="aa__records-heading">
                    Student Attendance Records
                  </h2>

                  <div className="aa__records-filters">
                    <input
                      type="date"
                      className="aa__filter-input"
                    />

                    <select className="aa__filter-select">
                      <option value="">All Sessions</option>
                      <option value="morning">Morning</option>
                      <option value="afternoon">Afternoon</option>
                      <option value="evening">Evening</option>
                    </select>
                  </div>
                </div>

                <div className="aa__table-wrapper">
                  <table className="aa__table">

                    <thead className="aa__table-head">
                      <tr className="aa__table-row">

                        <th className="aa__table-header">
                          Student Name
                        </th>

                        <th className="aa__table-header">
                          Date
                        </th>

                        <th className="aa__table-header">
                          Session
                        </th>

                        <th className="aa__table-header">
                          Check-In
                        </th>

                        <th className="aa__table-header">
                          Check-Out
                        </th>

                        <th className="aa__table-header">
                          Status
                        </th>

                        <th className="aa__table-header">
                          Actions
                        </th>

                      </tr>
                    </thead>

                    <tbody className="aa__table-body">
                      {studentattendanceRecords.map((record) => (
                        <tr
                          key={record.id}
                          className="aa__table-row"
                        >

                          <td className="aa__table-cell aa__table-cell--name">
                            {record.student}
                          </td>

                          <td className="aa__table-cell">
                            {record.date}
                          </td>

                          <td className="aa__table-cell">
                            <span className="aa__table-badge">
                              {record.session}
                            </span>
                          </td>

                          <td className="aa__table-cell">
                            {record.checkIn}
                          </td>

                          <td className="aa__table-cell">
                            {record.checkOut}
                          </td>

                          <td className="aa__table-cell">
                            <span
                              className={`aa__table-status aa__table-status--${record.status}`}
                            >
                              {record.status === 'present' ? (
                                <CheckCircle size={16} />
                              ) : (
                                <XCircle size={16} />
                              )}

                              {record.status}
                            </span>
                          </td>

                          <td className="aa__table-cell">
                            <div className="aa__table-actions">

                              <button
                                className="aa__table-btn aa__table-btn--view"
                                title="View"
                              >
                                <Eye size={16} />
                              </button>

                              <button
                                className="aa__table-btn aa__table-btn--delete"
                                title="Delete"
                              >
                                <Trash2 size={16} />
                              </button>

                            </div>
                          </td>

                        </tr>
                      ))}
                    </tbody>

                  </table>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </Adminmasterlayout>
  );
};

export default AdminAttendance;